"use client";

import { useEffect, useState } from "react";
import { initializeApp, getApps, deleteApp } from "firebase/app";
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { toast } from 'react-hot-toast';

export default function FirebaseListener() {
    const [hasStarted, setHasStarted] = useState(false);

    useEffect(() => {
        if (hasStarted) return;

        const startListener = async () => {
            try {
                const userToken: string | null = localStorage.getItem('userToken');
                const API_URL = process.env.NEXT_PUBLIC_CRESIVOX_BASE_URL;
                if (!userToken) return;

                // 1. Fetch this vendor's specific credentials from our DB
                const res = await fetch(`${API_URL}/firebase/get-credentials`, {
                    headers: { 'Authorization': userToken }
                });
                const json = await res.json() as any;

                if (!json.data || !json.data.api_key) return; 

                const firebaseConfig = {
                    apiKey: json.data.api_key,
                    authDomain: json.data.auth_domain,
                    projectId: json.data.project_id,
                    storageBucket: json.data.storage_bucket,
                    messagingSenderId: json.data.messaging_sender_id,
                    appId: json.data.app_id
                };

                // 2. Reinitialize cleanly with the vendor's own credentials
                if (getApps().length > 0) await deleteApp(getApps()[0]);
                const app = initializeApp(firebaseConfig);
                const messaging = getMessaging(app);

                // 3. Register the dynamic SW so it can receive background notifications
                 const swUrl = `/firebase-messaging-sw.js?apiKey=${firebaseConfig.apiKey}&projectId=${firebaseConfig.projectId}&messagingSenderId=${firebaseConfig.messagingSenderId}&appId=${firebaseConfig.appId}`;
                const registration = await navigator.serviceWorker.register(swUrl);
                
                // =========================================================
                // MULTI-DEVICE LOCALSTORAGE SYNC
                // =========================================================
                const permission = await Notification.requestPermission();
                
                if (permission === 'granted') {
                    // Generate token purely for this specific Browser session
                    const localToken = await getToken(messaging, {
                        vapidKey: json.data.vapid_key,
                        serviceWorkerRegistration: registration
                    });

                    // Check our local storage to see if THIS device uploaded its token to the API Array
                    const savedDeviceToken = localStorage.getItem("my_device_fcm_token");

                    if (localToken && localToken !== savedDeviceToken) {
                        // Append this browser to the backend array
                        await fetch(`${API_URL}/firebase/add-device-token`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": userToken
                            },
                            body: JSON.stringify({ device_token: localToken })
                        });
                        
                        // Remember that this laptop/phone is safely registered!
                        localStorage.setItem("my_device_fcm_token", localToken);
                    }
                }
                // 4. Handle foreground (tab is open) notifications as toasts
                // onMessage(messaging, (payload) => {
                //     if (payload.notification) {
                //         toast.success(
                //             `${payload.notification.title}\n${payload.notification.body}`,
                //             { duration: 5000, position: 'top-right' }
                //         );
                //     }
                // });
                                // 4. Handle foreground (tab is open) notifications
                onMessage(messaging, (payload) => {
                    // Try to read from both types just to be safe
                    const title = payload.notification?.title || payload.data?.title;
                    const body = payload.notification?.body || payload.data?.body;
                    
                    if (title) {
                        toast.success(
                            `${title}\n${body}`,
                            { duration: 5000, position: 'top-right' }
                        );
                    }
                });


                setHasStarted(true);

            } catch (err) {
                console.error('[FirebaseListener] Error starting dynamic listener:', err);
            }
        };

        startListener();

        const restart = () => setHasStarted(false);
        window.addEventListener('firebaseCredentialsUpdated', restart);
        return () => window.removeEventListener('firebaseCredentialsUpdated', restart);

    }, [hasStarted]);

    return null;
}